import { Callout, Intent } from "@blueprintjs/core";
import { useSearchParams } from "react-router-dom";

const Error = () => {
  const [searchParams] = useSearchParams();
  const errorMessage = searchParams.get("message");
  return (
    <div>
      <Callout
        intent={Intent.DANGER}
        title={errorMessage ? errorMessage : `${process.env.REACT_APP_TITLE} has encountered an error.`}
      />
    </div>
  );
};

export default Error;
